import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { whatsappService } from '../../services/api';
import '../../styles/WhatsAppPlantillas.css';

function Plantillas() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [plantillas, setPlantillas] = useState([]);
  const [vista, setVista] = useState('lista'); // lista, nueva, editar
  const [plantillaActual, setPlantillaActual] = useState(null);

  // Form states
  const [formData, setFormData] = useState({
    nombre: '',
    tipo: 'recordatorio',
    asunto: '',
    contenido: '',
    activo: true
  });

  const [message, setMessage] = useState({ type: '', text: '' });

  const variablesDisponibles = [
    { cat: 'Cliente', vars: ['cliente_nombre', 'cliente_cedula', 'cliente_telefono'] },
    { cat: 'Préstamo', vars: ['prestamo_id', 'monto_prestamo', 'saldo_pendiente', 'total_pagado', 'modalidad', 'monto_cuota', 'fecha_proxima_cuota', 'fecha_vencimiento', 'monto_pagar', 'dias_vencido', 'mora_acumulada'] },
    { cat: 'Pago', vars: ['monto_pagado', 'fecha_pago', 'recibo_numero', 'saldo_restante'] },
    { cat: 'Empresa', vars: ['empresa_nombre', 'empresa_telefono', 'empresa_direccion'] }
  ];

  useEffect(() => {
    cargarPlantillas();
  }, []);

  const cargarPlantillas = async () => {
    try {
      setLoading(true);
      const response = await whatsappService.getPlantillas();
      console.log('Respuesta plantillas:', response.data);
      setPlantillas(response.data.plantillas || []);

      if (!response.data.plantillas || response.data.plantillas.length === 0) {
        showMessage('info', 'No hay plantillas creadas. Crea tu primera plantilla');
      }
    } catch (error) {
      console.error('Error cargando plantillas:', error);
      console.error('Detalles del error:', error.response?.data || error.message);

      // Si es error de autenticación, no mostrar mensaje (PrivateRoute manejará la redirección)
      if (error.response?.status === 401) {
        return;
      }

      showMessage('error', `Error al cargar plantillas: ${error.response?.data?.error || error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleNueva = () => {
    setPlantillaActual(null);
    setFormData({
      nombre: '',
      tipo: 'recordatorio',
      asunto: '',
      contenido: '',
      activo: true
    });
    setVista('nueva');
  };

  const handleEditar = (plantilla) => {
    setPlantillaActual(plantilla);
    setFormData({
      nombre: plantilla.nombre,
      tipo: plantilla.tipo,
      asunto: plantilla.asunto || '',
      contenido: plantilla.contenido,
      activo: plantilla.activo
    });
    setVista('editar');
  };

  const handleGuardar = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      // Extraer variables del contenido
      const variablesEncontradas = [];
      const regex = /{([^}]+)}/g;
      let match;
      while ((match = regex.exec(formData.contenido)) !== null) {
        if (!variablesEncontradas.includes(match[1])) {
          variablesEncontradas.push(match[1]);
        }
      }

      const data = {
        ...formData,
        variables: variablesEncontradas
      };

      if (vista === 'nueva') {
        await whatsappService.createPlantilla(data);
        showMessage('success', '✅ Plantilla creada exitosamente');
      } else {
        await whatsappService.updatePlantilla(plantillaActual.id, data);
        showMessage('success', '✅ Plantilla actualizada exitosamente');
      }

      await cargarPlantillas();
      setVista('lista');
    } catch (error) {
      showMessage('error', error.response?.data?.error || 'Error al guardar plantilla');
    } finally {
      setLoading(false);
    }
  };

  const handleEliminar = async (id) => {
    if (!window.confirm('¿Estás seguro de eliminar esta plantilla?')) {
      return;
    }

    try {
      setLoading(true);
      await whatsappService.deletePlantilla(id);
      showMessage('success', '✅ Plantilla eliminada');
      await cargarPlantillas();
    } catch (error) {
      showMessage('error', error.response?.data?.error || 'Error al eliminar');
    } finally {
      setLoading(false);
    }
  };

  const handleToggleActivo = async (plantilla) => {
    try {
      await whatsappService.updatePlantilla(plantilla.id, {
        ...plantilla,
        activo: !plantilla.activo
      });
      await cargarPlantillas();
    } catch (error) {
      showMessage('error', 'Error al actualizar estado');
    }
  };

  const insertarVariable = (variable) => {
    const textarea = document.getElementById('contenido-textarea');
    const inicio = textarea.selectionStart;
    const fin = textarea.selectionEnd;
    const texto = formData.contenido;
    const nuevoTexto = texto.substring(0, inicio) + `{${variable}}` + texto.substring(fin);

    setFormData({ ...formData, contenido: nuevoTexto });

    // Mantener el foco
    setTimeout(() => {
      textarea.focus();
      textarea.setSelectionRange(inicio + variable.length + 2, inicio + variable.length + 2);
    }, 0);
  };

  const showMessage = (type, text) => {
    setMessage({ type, text });
    setTimeout(() => setMessage({ type: '', text: '' }), 5000);
  };

  const getTipoLabel = (tipo) => {
    const labels = {
      'recordatorio': 'Recordatorio',
      'vencido': 'Vencido',
      'confirmacion': 'Confirmación',
      'estado_cuenta': 'Estado de Cuenta',
      'personalizado': 'Personalizado'
    };
    return labels[tipo] || tipo;
  };

  const getTipoColor = (tipo) => {
    const colors = {
      'recordatorio': 'blue',
      'vencido': 'red',
      'confirmacion': 'green',
      'estado_cuenta': 'purple',
      'personalizado': 'gray'
    };
    return colors[tipo] || 'gray';
  };

  if (loading && plantillas.length === 0) {
    return (
      <div className="plantillas-page">
        <div className="loading-container">
          <div className="spinner"></div>
          <p>Cargando plantillas...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="plantillas-page">
      <div className="page-header">
        <div>
          <h1>📝 Plantillas de Mensajes</h1>
          <p className="subtitle">Gestiona plantillas reutilizables para WhatsApp</p>
        </div>
        <div className="header-actions">
          {vista !== 'lista' && (
            <button onClick={() => setVista('lista')} className="btn btn-secondary">
              ← Volver a Lista
            </button>
          )}
          {vista === 'lista' && (
            <>
              <button onClick={handleNueva} className="btn btn-success">
                ➕ Nueva Plantilla
              </button>
              <button onClick={() => navigate('/whatsapp')} className="btn btn-secondary">
                ← Volver
              </button>
            </>
          )}
        </div>
      </div>

      {message.text && (
        <div className={`message-alert ${message.type}`}>
          {message.text}
        </div>
      )}

      {/* VISTA LISTA */}
      {vista === 'lista' && (
        <div className="plantillas-grid">
          {plantillas.length === 0 ? (
            <div className="empty-state">
              <p>📭 No hay plantillas creadas</p>
              <button onClick={handleNueva} className="btn btn-primary">
                Crear Primera Plantilla
              </button>
            </div>
          ) : (
            plantillas.map((plantilla) => (
              <div key={plantilla.id} className="plantilla-card">
                <div className="plantilla-header">
                  <div>
                    <h3>{plantilla.nombre}</h3>
                    <span className={`tipo-badge tipo-${getTipoColor(plantilla.tipo)}`}>
                      {getTipoLabel(plantilla.tipo)}
                    </span>
                  </div>
                  <div className="plantilla-toggle">
                    <label className="switch">
                      <input
                        type="checkbox"
                        checked={plantilla.activo}
                        onChange={() => handleToggleActivo(plantilla)}
                      />
                      <span className="slider"></span>
                    </label>
                  </div>
                </div>

                {plantilla.asunto && (
                  <div className="plantilla-asunto">
                    <strong>Asunto:</strong> {plantilla.asunto}
                  </div>
                )}

                <div className="plantilla-contenido">
                  {plantilla.contenido.substring(0, 200)}
                  {plantilla.contenido.length > 200 && '...'}
                </div>

                {plantilla.variables && plantilla.variables.length > 0 && (
                  <div className="plantilla-variables">
                    <small>Variables:</small>
                    <div className="vars-chips">
                      {plantilla.variables.slice(0, 5).map((v, i) => (
                        <span key={i} className="var-chip">{`{${v}}`}</span>
                      ))}
                      {plantilla.variables.length > 5 && (
                        <span className="var-chip">+{plantilla.variables.length - 5}</span>
                      )}
                    </div>
                  </div>
                )}

                <div className="plantilla-actions">
                  <button
                    onClick={() => handleEditar(plantilla)}
                    className="btn btn-outline btn-small"
                  >
                    ✏️ Editar
                  </button>
                  <button
                    onClick={() => handleEliminar(plantilla.id)}
                    className="btn btn-danger btn-small"
                  >
                    🗑️ Eliminar
                  </button>
                </div>
              </div>
            ))
          )}
        </div>
      )}

      {/* VISTA FORMULARIO (Nueva/Editar) */}
      {(vista === 'nueva' || vista === 'editar') && (
        <form onSubmit={handleGuardar} className="plantilla-form">
          <div className="form-grid-plantilla">
            {/* Columna Izquierda - Formulario */}
            <div className="form-column">
              <div className="form-card">
                <h3>{vista === 'nueva' ? '➕ Nueva Plantilla' : '✏️ Editar Plantilla'}</h3>

                <div className="form-group">
                  <label>Nombre de la Plantilla *</label>
                  <input
                    type="text"
                    value={formData.nombre}
                    onChange={(e) => setFormData({ ...formData, nombre: e.target.value })}
                    placeholder="Ej: Recordatorio de Pago"
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Tipo *</label>
                  <select
                    value={formData.tipo}
                    onChange={(e) => setFormData({ ...formData, tipo: e.target.value })}
                    required
                  >
                    <option value="recordatorio">Recordatorio</option>
                    <option value="vencido">Préstamo Vencido</option>
                    <option value="confirmacion">Confirmación de Pago</option>
                    <option value="estado_cuenta">Estado de Cuenta</option>
                    <option value="personalizado">Personalizado</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>Asunto (opcional)</label>
                  <input
                    type="text"
                    value={formData.asunto}
                    onChange={(e) => setFormData({ ...formData, asunto: e.target.value })}
                    placeholder="Breve descripción"
                  />
                </div>

                <div className="form-group">
                  <label>Contenido del Mensaje *</label>
                  <textarea
                    id="contenido-textarea"
                    value={formData.contenido}
                    onChange={(e) => setFormData({ ...formData, contenido: e.target.value })}
                    rows="15"
                    placeholder="Escribe el contenido del mensaje aquí..."
                    required
                  />
                  <small className="char-count">{formData.contenido.length} caracteres</small>
                </div>

                <div className="form-group">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      checked={formData.activo}
                      onChange={(e) => setFormData({ ...formData, activo: e.target.checked })}
                    />
                    <span>Plantilla activa</span>
                  </label>
                </div>

                <div className="form-actions">
                  <button type="submit" className="btn btn-success" disabled={loading}>
                    {loading ? '⏳ Guardando...' : '💾 Guardar Plantilla'}
                  </button>
                  <button
                    type="button"
                    onClick={() => setVista('lista')}
                    className="btn btn-secondary"
                  >
                    Cancelar
                  </button>
                </div>
              </div>
            </div>

            {/* Columna Derecha - Variables y Preview */}
            <div className="form-column">
              <div className="form-card">
                <h3>🔧 Variables Disponibles</h3>
                <p className="help-text">
                  Haz clic en una variable para insertarla en el mensaje
                </p>

                {variablesDisponibles.map((categoria, idx) => (
                  <div key={idx} className="variable-category">
                    <h4>{categoria.cat}</h4>
                    <div className="variables-grid">
                      {categoria.vars.map((variable, i) => (
                        <button
                          key={i}
                          type="button"
                          className="var-button"
                          onClick={() => insertarVariable(variable)}
                        >
                          {`{${variable}}`}
                        </button>
                      ))}
                    </div>
                  </div>
                ))}
              </div>

              <div className="form-card">
                <h3>📱 Preview</h3>
                {formData.contenido ? (
                  <div className="whatsapp-preview">
                    <div className="preview-bubble">
                      {formData.contenido}
                    </div>
                    <small className="preview-note">
                      * Las variables se reemplazarán con datos reales al enviar
                    </small>
                  </div>
                ) : (
                  <div className="empty-state">
                    <p>Escribe un mensaje para ver el preview</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </form>
      )}
    </div>
  );
}

export default Plantillas;
